import Vue from 'vue';

import JobSlider from './JobSlider';

Vue.component('brku-job-slider', JobSlider);